import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

const UPDATE_JOB_STATUS = gql`
  mutation UpdateJobStatus($input: UpdateJobStatusInput!) {
    updateJobStatus(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/UpdateJobStatus').type;
export type UpdateJobStatusVariables = OperationVariables<
  typeof UPDATE_JOB_STATUS
>;
export type UpdateJobStatusInput = UpdateJobStatusVariables['input'];
export type UpdateJobStatusResult = OperationData<typeof UPDATE_JOB_STATUS>;

export const useUpdateJobStatus = () => {
  const tuple = useMutation(UPDATE_JOB_STATUS);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        refetchQueries: [
          'SearchJobsWithTasks',
          'SearchTasks',
          'SearchJobs',
          'GetJob',
        ],
        awaitRefetchQueries: true,
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
